import type {ReactElement} from 'react';
import type {QRTextInput} from '@Libraries/qr-code/qr-code.types';
import {QRPayloadField, QR_PAYLOAD_MAX_BYTES} from '@Libraries/qr-code/qr-code.types';
import {QRField} from '@Components/qr-code-generator/components/qr-field/qr-field';
import {clampToUtf8ByteLength} from '@Libraries/qr-code/qr-payload-encoding.library';
import {getTextContentHelpText} from '@Components/qr-code-generator/qr-code-generator.library';
import type {QRFormProps} from '@Components/qr-code-generator/qr-code-generator.types';

export function QRTextForm({input, issues, onPatch}: QRFormProps<QRTextInput>): ReactElement {
  return (
    <QRField
      label={window.i18next.t('pmwjs_qr_generator_text_label')}
      placeholder={window.i18next.t('pmwjs_qr_generator_text_placeholder')}
      helpText={getTextContentHelpText(input.text)}
      value={input.text}
      field={QRPayloadField.TEXT_CONTENT}
      issues={issues}
      isMultiline
      onValueChange={(text): void => {
        onPatch({text: clampToUtf8ByteLength(text, QR_PAYLOAD_MAX_BYTES)});
      }}
    />
  );
}
